"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleValue = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactSelect = require("react-select");
var SingleValue = exports.SingleValue = /*#__PURE__*/_react["default"].memo(function (props) {
  var data = props.data,
    innerProps = props.innerProps,
    selectProps = props.selectProps;
  var custom = data.custom,
    CustomComponent = data.CustomComponent;
  var menuIsOpen = selectProps.menuIsOpen;
  var Component = CustomComponent && (0, _styledComponents["default"])(CustomComponent).withConfig({
    displayName: "SingleValue__Component",
    componentId: "sc-1qd5e0t-0"
  })(["font-size:16px;font-weight:", ";color:", ";"], menuIsOpen ? 400 : 600, menuIsOpen ? 'lightgrey' : 'black');
  return custom && Component ? /*#__PURE__*/_react["default"].createElement(Component, innerProps) : /*#__PURE__*/_react["default"].createElement(_reactSelect.components.SingleValue, props);
});
SingleValue.displayName = 'SingleValue';